(ns common.locale
  (:require ["@mui/x-date-pickers-pro" :refer [LocalizationProvider]]
            ["@mui/x-date-pickers-pro/AdapterMoment" :refer [AdapterMoment]]
            ["moment/min/locales"]
            ["moment/min/moment-with-locales$default" :as moment]
            [clojure.string :as str]
            [uix.core :refer [$ defui]]))

(defn set-user-locale!
  "Sets the locale based on the given `user-locale` (e.g. \"de-DE\", \"fr-FR\").
   If the locale language is English, it is used directly.
   Otherwise, a custom locale is created that inherits regional formatting rules
   (date order, week start, etc.) from the user's language locale, but replaces
   all language-specific strings (months, weekdays, relative time) with their
   English equivalents. This ensures consistent English text output while still
   respecting the user's regional date/time conventions."
  [user-locale]
  (let [[language country] (str/split user-locale #"-")
        en-data (.localeData moment "en")]
    (if (= language "en")
      (.locale moment user-locale)
      (.defineLocale moment
                     (str "en-" country)
                     #js {:parentLocale language
                          :months (.months en-data)
                          :monthsShort (.monthsShort en-data)
                          :weekdays (.weekdays en-data)
                          :weekdaysShort (.weekdaysShort en-data)
                          :weekdaysMin (.weekdaysMin en-data)
                          :relativeTime (.-_relativeTime en-data)
                          :calendar (.-_calendar en-data)
                          :ordinal (.-ordinal en-data)
                          :dayOfMonthOrdinalParse (.-_dayOfMonthOrdinalParse en-data)}))))

(set-user-locale! js/navigator.language)

(defui locale-provider [{:keys [children]}]
  ($ LocalizationProvider
     {:dateAdapter AdapterMoment
      :dateLibInstance moment
      :adapterLocale js/navigator.language}
     children))
